module.exports = __webpack_public_path__ + "img/madeireiras-a89a4b48.jpg";